import SubstrateClassTape from "./SubstrateClassTape";

export default interface SubstrateClassTapeSelection {
  kind: "tape";
  substrateClass: SubstrateClassTape;
  substrateClassType: string | null;
}

export function labelOfSelectionTape(selection: SubstrateClassTapeSelection): string {
  return (
    selection.substrateClass.productName + (selection.substrateClassType ? ` (${selection.substrateClassType})` : "")
  );
}

export function keyOfSelectionTape(selection: SubstrateClassTapeSelection): string {
  return selection.substrateClass.productId + (selection.substrateClassType || "");
}
